/**
 * Move one layer to an exact bottom-to-top position without mutating the input.
 * Index 0 is the bottom layer; the highest index is the top layer.
 */
export function moveLayerToIndex(layers, fromIndex, toIndex) {
    if (!Array.isArray(layers) || layers.length < 2) return layers ? [...layers] : [];
    if (fromIndex < 0 || fromIndex >= layers.length) return [...layers];

    const boundedTarget = Math.max(0, Math.min(toIndex, layers.length - 1));
    if (fromIndex === boundedTarget) return [...layers];

    const next = [...layers];
    const [moved] = next.splice(fromIndex, 1);
    next.splice(boundedTarget, 0, moved);
    return next;
}
